var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8 0H10.2C4.5667 0 0 4.43238 0 9.9V56.1C0 61.5676 4.5667 66 10.2 66H57.8C63.4333 66 68 61.5676 68 56.1V9.9C68 4.43238 63.4333 0 57.8 0Z",
    fill: "#DC4639"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3667 30.1644V36.223H34.9292C34.6636 38.6722 32.1402 43.3128 25.3667 43.3128C19.6558 43.3128 15.0074 38.6722 15.0074 33.0003C15.0074 27.3284 19.3902 22.6878 25.1011 22.6878C28.4214 22.6878 30.6792 23.9769 31.8745 25.137L36.523 20.8831C34.1408 18.689 31.1416 17.2299 27.9048 16.6905C24.6681 16.151 21.3392 16.5554 18.3394 17.8526C15.3395 19.1497 12.8033 21.2813 11.0518 23.9776C9.30032 26.674 8.4121 29.8139 8.49954 33.0003C8.49954 42.0238 16.0699 49.3714 25.3667 49.3714C35.1949 49.3714 41.5699 42.5394 41.5699 33.2581L41.3042 30.1644",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6558 24.75V39.9609ZM61.4917 32.3555H45.8198Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6558 24.75V39.9609M61.4917 32.3555H45.8198",
    stroke: "white",
    strokeWidth: 2.00313
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.d95242eeb42db1e04018efe7ebbe1a2d.svg";
export { ForwardRef as ReactComponent };